module.exports = __webpack_public_path__ + "static/img/10.c0dc2ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/zh/10.png
// module id = o+H9
// module chunks = 0